<template>
    <ul class="text-sm text-gray-600 usps">
        <li v-for="(usp, index) in usps" :key="index" :hidden="!returnable && index == 2">
            <fa :icon="['fal', 'check']" class="text-dgreen mr-2 w-4" />
            <span v-html="usp" />
        </li>
    </ul>
</template>

<script setup>
import { useAppStore } from '@/stores/appStore.js';
import { computed } from 'vue';

const $appStore = useAppStore();

defineProps({
    returnable: {
        type: [Boolean, Number],
        default: false,
    },
});

const usps = computed(() => {
    let settings = $appStore.settings;
    return [settings['usp-1'], settings['usp-2'], settings['usp-3'], settings['usp-4']];
});
</script>